import angular from "angular";
import uiRouter from "angular-ui-router";
import "ngstorage";
import "angular-sanitize";
import "ng-csv";
import auth from "../../services/auth.js";
import events from "../../services/events.js";
import security from "../../services/security.js";
import env from "../../services/env.js";

class EventrosterController {
  constructor(
    $http,
    $localStorage,
    $scope,
    $state,
    JobsService,
    AuthService,
    EventsService,
    $stateParams,
    SecurityService,
    $rootScope,
    EnvService,
    $timeout,
    $location
  ) {
    this.name = "eventroster";
    $localStorage.activeStateName = "events";

    if (!AuthService.isLoggedIn()) {
      $state.go("signin");
      return;
    }

    this.$http = $http;
    this.$localStorage = $localStorage;
    this.$state = $state;
    this.$auth = AuthService;
    this.$events = EventsService;
    this.$security = SecurityService;
    this.$stateParams = $stateParams;
    this.$scope = $scope;
    this.$rootScope = $rootScope;
    this.$jobs = JobsService;
    this.$env = EnvService;
    this.googleMapKey = this.$auth.$env.EnvironmentConfig.mapsKey;
    this.fullGoogleUrl = "https://maps.googleapis.com/maps/api/js?libraries=places&key=" + this.googleMapKey;
    this.$timeout = $timeout;
    this.bulkCheckInArray = [];
    this.bulkCheckOutArray = [];
    this.currentUser = this.$auth.getUserData();
    this.remain_loading_count = 1;
    this.jobblers = [];
    this.ratingsMap = [];
    this.$location = $location;
    this.showRatingsWarningToUser = false;
    this.csvName = "jobblers" + moment().format() + ".csv";
    $localStorage.activeStateName = "events";

    var _this = this;

    _this.$timeout(function () {
      _this.$rootScope.$emit("SetLoaderDialog", {type: 7, total: 1});
    });

    _this.UpdateRosterPageWithConfirmationDataListener = _this.$rootScope.$on("UpdateRosterPageWithConfirmationData", function ($rootScope, params) {
      console.log("UpdateRosterPageWithConfirmationDataListener");
      console.dir(params);
      let data = {};
      data.userId = params.user_to_update.id;
      data.timestamp = params.timestamp;
      data.type = params.type;
      _this.updateConfirmationUI(data);
    });

    _this.$scope.$on("$destroy", _this.UpdateRosterPageWithConfirmationDataListener);

    console.log("what is ngCsv");
    //console.dir(ngCsv);

    console.log("what are the state params");
    console.dir(_this.$stateParams.eventId);
    var id = parseInt(_this.$stateParams.eventId, 10);

    _this.$events.getEventByIdTrimmedRoster(id).then(function (event) {
      console.log("what is the event");
      console.dir(event.data);

      _this.event = event.data;

      _this.$timeout(function () {
        _this.$rootScope.$emit("SetEventToEventDialog", {
          event: _this.event,
        });
        _this.$rootScope.$emit("SetEventToEventSidebar", {
          event: _this.event,
        });
      });

      if (_this.event.isClosed === true) {
        $timeout(function () {
          $("eventsidebar .jobs-complete-sidebar li:nth-child(3)").removeClass().addClass("active");
        }, 1000);
      } else {
        $timeout(function () {
          $("eventsidebar .jobs-complete-sidebar li:nth-child(4)").removeClass().addClass("active");
        }, 1000);
      }

      _this.subEventId = _this.event.subEvents[0].id;

      $timeout(function () {
        _this.formatAddressForMaps();
      }, 3000);

      if (_this.event.isSourcingPost) {
        _this.pagestatus = 2;
        _this.loadApplicantsForRosterPage();
      } else {
        if (_this.$stateParams.shiftId) {
          _this.pagestatus = 2;

          _this.loadApplicantsForRosterPage();

          _this.$timeout(function () {
            _this.getCoordinatesForCheckingJobblersInAndOut(_this.event.contactInfo, _this.$stateParams.shiftId);
          }, 100);

          _this.name = "eventroster1";
        } else {
          _this.pagestatus = 1;
          _this.remain_loading_count = 0;
          _this.name = "eventroster";

          try {
            event.data.subEvents[0].deduppedJobbles[0].shifts.sort(function (a, b) {
              return new Date(a.timeInterval.startTime).getTime() - new Date(b.timeInterval.startTime).getTime();
            });
          } finally {
            _this.shiftss = event.data.subEvents[0].deduppedJobbles[0].shifts;

            console.log("here are the shiftss");
            console.dir(_this.shiftss);
          }
        }
      }
    });
  }

  printRoster() {
    var _this = this;
    //if (navigator.userAgent.toLowerCase().indexOf('chrome') > -1) {
    //console.log('we have chrome');
    var popupWin = window.open("", "_blank", "width=800,height=800,scrollbars=no,menubar=no,toolbar=no,location=no,status=no,titlebar=no");
    popupWin.window.focus();
    popupWin.document.write(
      "<!DOCTYPE html><html><head>" +
        '<link rel="stylesheet" type="text/css" href="/app/vendor/css/style-print.css" />' +
        '</head><body onload="window.print()"><div class="print-body">' +
        _this.printFriendlyTemplate +
        "</div></html>"
    );
    popupWin.onbeforeunload = function (event) {
      popupWin.close();
      return ".\n";
    };
    popupWin.onabort = function (event) {
      popupWin.document.close();
      popupWin.close();
    };
    //}
  }

  getLatAndLngOfCurrentShiftForCheckIn(shift) {
    var _this = this;

    var geocoder = new google.maps.Geocoder();
    var address = shift.contactInfo.streetLine1 + " " + shift.contactInfo.city + ", " + shift.contactInfo.state + " " + shift.contactInfo.zipCode;

    geocoder.geocode({address: address}, function (results, status) {
      if (status === google.maps.GeocoderStatus.OK && results.length > 0) {
        var location = results[0].geometry.location;
        var myLatLngEv = {lat: location.lat(), lng: location.lng()};
        _this.coords = myLatLngEv;
      }
    });
  }

  findOutIfEventHaveALiveShift(applications) {
    var _this = this;

    try {
      applications.forEach(function (application) {
        console.log("here we go");
        console.dir(application);

        var liveShift = _this.$security.isThisEventLive(application.jobble.shifts);

        if (liveShift.eventIsLive === true) {
          application.liveShift = liveShift;
          application.hasLiveShift = true;
        } else {
          application.liveShift = undefined;
          application.hasLiveShift = undefined;
        }

        _this.getLatAndLngOfCurrentShiftForCheckIn(liveShift);
      });
    } finally {
      _this.jobblers = applications;
    }
  }

  toggleCheckin(jobbler) {
    var _this = this;

    if (_this.bulkCheckOutArray.length > 0) {
      alert(
        "You cannot check jobblers in while you are currently checking out. Please first finish checking your jobblers in before taking this action."
      );
    } else {
      if (jobbler.isSelected) {
        jobbler.isSelected = undefined;
        jobbler.isSelectedRow = undefined;
        var index = -1;
        for (var i = _this.bulkCheckInArray.length - 1; i >= 0; i--) {
          if (_this.bulkCheckInArray[i].applicantId == jobbler.applicantId) {
            index = i;
            break;
          }
        }
        if (index != -1) _this.bulkCheckInArray.splice(index, 1);
      } else {
        jobbler.isSelected = "checkin-toggle";
        jobbler.isSelectedRow = "check-in-toggle-row";
        _this.bulkCheckInArray.push(jobbler);
      }
    }
  }

  toggleCheckout(jobbler) {
    var _this = this;
    if (_this.bulkCheckInArray.length > 0) {
      alert(
        "You cannot check jobblers out while you are currently checking in. Please first finish checking your jobblers out before taking this action."
      );
    } else {
      if (jobbler.isSelected) {
        jobbler.isSelected = undefined;
        jobbler.isSelectedRow = undefined;
        var index = -1;
        for (var i = _this.bulkCheckOutArray.length - 1; i >= 0; i--) {
          if (_this.bulkCheckOutArray[i].applicantId == jobbler.applicantId) {
            index = i;
            break;
          }
        }

        if (index != -1) _this.bulkCheckOutArray.splice(index, 1);
      } else {
        jobbler.isSelected = "checkout-toggle";
        jobbler.isSelectedRow = "check-out-toggle-row";
        _this.bulkCheckOutArray.push(jobbler);
      }
    }
  }

  checkJobblersInOrOut(type) {
    console.log("type");
    console.dir(type);

    var _this = this;
    var arrayTemp;
    _this.remain_loading_count = 1;

    var arrayOfJobblesAndApplicants = [];

    var payLoad = {jobblesAndApplicants: []};

    try {
      if (type === "checkin") {
        arrayTemp = _this.bulkCheckInArray;
      }
      if (type === "checkout") {
        arrayTemp = _this.bulkCheckOutArray;
      }

      arrayTemp.forEach(function (application) {
        console.log("each application");
        console.dir(application);

        try {
          application.jobble.shifts.forEach(function (s, i) {
            let index = i + 1;
            let st = moment(s.timeInterval.startTime).subtract(15, "minutes");
            let et;

            if (index === application.jobble.shifts.length) {
              var indexLast = index - 1;
              et = moment(application.jobble.shifts[indexLast].timeInterval.endTime).add(500, "hours");
            } else {
              et = moment(application.jobble.shifts[index].timeInterval.startTime).subtract(15, "minutes");
            }
            if (moment().isAfter(st) && moment().isBefore(et)) {
              application.currentShiftId = s.id;
            }
          });
        } finally {
          var jobbleAndApplicant = {};

          jobbleAndApplicant.jobble = application.jobble.id;
          jobbleAndApplicant.applicant = application.applicantId;
          jobbleAndApplicant.coord = _this.coords;
          jobbleAndApplicant.shift = application.currentShiftId;
          payLoad.jobblesAndApplicants.push(jobbleAndApplicant);
        }
      });
    } finally {
      _this.$events.checkJobblerIn(payLoad, type).then(
        function (response) {
          _this.handleResponse(response);
        },
        function (data) {
          _this.remain_loading_count = 0;
          _this.$timeout(function () {
            alert("failure: contact support");
          }, 400);
        }
      );
    }
  }

  handleResponse(response) {
    console.log("in handle response");
    console.dir(response);

    var _this = this;

    if (response.status === 200) {
      /*
		  _this.$events.getAcceptedApplicationsTrimmedRoster(_this.event.subEvents[0].id, 200).then(function(acceptedApplications) {

			  console.log('reloading the accepted applicants2');
			  console.dir(acceptedApplications);

			  var applications = acceptedApplications.data;

			  _this.findOutIfEventHaveALiveShift(applications);

			  try {
				  applications.forEach(function(application, i){
					  application.smallPic = _this.$security.getJobblersPicture('75x75', application.applicant);
					  application.mediumPic = _this.$security.getJobblersPicture('160x160', application.applicant);
				  });
			  } finally {
				  applications.sort(function(a,b) {
					  if(a.applicant.lastName < b.applicant.lastName) return -1;
					  if(a.applicant.lastName > b.applicant.lastName) return 1;
					  return 0;
				  })

				  _this.$timeout(function() {
					  _this.bulkCheckInArray = [];
					  _this.bulkCheckOutArray = [];
					  _this.remain_loading_count = 0;
					  _this.$rootScope.globalModalType = { "type" : 5 };
					  jQuery('#show-application-global-modal').trigger('click');
				  }, 300);
			  }
		  })
		*/
    } else {
      alert("error contact admin");
    }
  }

  formatAddressForMaps() {
    var _this = this;

    //console.log('what are we actually getting here?');

    var city = _this.event.contactInfo.city;
    var street = _this.event.contactInfo.streetLine1;
    var state = _this.event.contactInfo.state;
    //var zipCode = _this.event.contactInfo.zipCode;
    var address = street + ", " + city + ", " + state;

    _this.address = address;
  }

  showAddress(contactinfo) {
    var _this = this;

    var city = _this.event.contactInfo.city;
    var street = _this.event.contactInfo.streetLine1;
    var state = _this.event.contactInfo.state;
    var address = street + ", " + city + ", " + state;

    return address;
  }

  viewShiftRoster(shift, index) {
    var _this = this;
    _this.$location.path("/event/" + _this.event.id + "/roster/" + shift.id).search({i: index});
  }

  showStartTime(time) {
    return moment(time).format("dddd, MMM DD");
  }

  showTimeShift(time) {
    return moment(time).format("dddd, MMM DD");
  }

  showmanagerCheckInTime(time) {
    /*
	  var x = null;

	  if (!time) {
		  x = "--";
	  } else {
		  x = moment(time).format("hh:mm A");
	  }

	  return x;
	  */

    return time;
  }

  showmanagerCheckOutTime(time) {
    /*
	  var x = null;

	  if (!time) {
		  x = "--";
	  } else {
		  x = moment(time).format("hh:mm A");
	  }

	  return x;
	  */

    return time;
  }

  viewShiftRoster(shift, index) {
    var _this = this;
    _this.$location.path("/event/" + _this.event.id + "/roster/" + shift.id).search({i: index});
  }

  launchConfirmModal(app) {
    var _this = this;
    console.log("launchConfirmModal");
    console.dir(app);

    _this.$timeout(function () {
      _this.$rootScope.$emit("SetShiftToModal", app);
    });
  }

  launchEditModal(app) {
    var _this = this;

    console.log("launchEditModal");
    console.dir(app);
    app.isEdit = true;
    _this.$timeout(function () {
      _this.$rootScope.$emit("SetShiftToModal", app);
    });
  }

  loadApplicantsForRosterPage(max, offset) {
    var _this = this;
    let csv = [];
    if (!max) {
      max = 100;
    }
    if (!offset) {
      offset = 0;
    }
    _this.jobblers = [];
    _this.$events.getAcceptedApplicationsTrimmedRoster(_this.event.subEvents[0].id, max, offset).then(function (acceptedApplications) {
      var applications = acceptedApplications.data;
      try {
        try {
          applications.forEach(function (application, i) {
            let csvObj = {
              last_name: application.applicant.lastName,
              first_name: application.applicant.firstName,
              number: application.applicant.homeContactInfo.phoneMobile,
              email: application.applicant.email,
              post_title: _this.event.name,
              job_type: _this.event.subEvents[0].deduppedJobbles[0].jobbleType.name,
              city: _this.event.contactInfo.city,
              state: _this.event.contactInfo.state,
              zip: _this.event.contactInfo.zipCode,
              apply_date: application.dateCreated,
            };
            csv.push(csvObj);
            application.smallPic = application.applicant.filePROFILE_IMAGE1IMG_75x75;
            application.mediumPic = application.applicant.filePROFILE_IMAGE1IMG_75x75;
            application.jobble.shifts.sort(function (a, b) {
              return new Date(a.timeInterval.startTime).getTime() - new Date(b.timeInterval.startTime).getTime();
            });

            _this.fixApplicantPhone(application);
          });
        } finally {
          applications.sort(function (a, b) {
            if (a.applicant.lastName < b.applicant.lastName) return -1;
            if (a.applicant.lastName > b.applicant.lastName) return 1;
            return 0;
          });
          csv.sort(function (a, b) {
            if (a.last_name < b.last_name) return -1;
            if (a.last_name > b.last_name) return 1;
            return 0;
          });
          _this.findCurrentShift(applications);
          _this.setTimeZones(applications);
        }
      } finally {
        _this.csv = csv;
        _this.$timeout(function () {
          _this.setPrintFriendlyVersion(applications);
        }, 500);
      }
    });
  }

  setPrintFriendlyVersion(applications) {
    var _this = this;
    _this.printFriendlyTemplate = "<table><thead><th>Last Name</th><th>First Name</th><th>Email</th><th>Number</th></thead>";
    let endOfTable = "</tbody></table>";
    let arrayOfRows = [];
    let stringOfHtml = "";
    if (applications) {
      try {
        for (var i = 0; i < applications.length; i++) {
          arrayOfRows.push(
            "<tr><td>" +
              applications[i].applicant.lastName +
              "</td><td>" +
              applications[i].applicant.firstName +
              "</td><td>" +
              applications[i].applicant.email +
              "</td><td>" +
              applications[i].applicant.homeContactInfo.phoneMobile +
              "</td></tr>"
          );
          _this.printFriendlyTemplate =
            _this.printFriendlyTemplate +
            "<tr><td>" +
            applications[i].applicant.lastName +
            "</td><td>" +
            applications[i].applicant.firstName +
            "</td><td>" +
            applications[i].applicant.email +
            "</td><td>" +
            applications[i].applicant.homeContactInfo.phoneMobile +
            "</td></tr>";
        }
      } finally {
        _this.printFriendlyTemplate = _this.printFriendlyTemplate + endOfTable;
        _this.remain_loading_count = 0;
      }
    }
  }

  fixApplicantPhone(application) {
    var _this = this;

    if (application.applicant.homeContactInfo) {
      if (application.applicant.homeContactInfo.phoneMobile) {
        let num = application.applicant.homeContactInfo.phoneMobile;
        if (num.charAt(0) === "1") {
          num = num.slice(1, num.length);
        }
        let cleaned = ("" + num).replace(/\D/g, "");
        var match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
        if (match) {
          application.applicant.homeContactInfo.phoneMobile = "(" + match[1] + ") " + match[2] + "-" + match[3];
        } else {
          application.applicant.homeContactInfo.phoneMobile = num;
        }
      } else {
        application.applicant.homeContactInfo = {};
        application.applicant.homeContactInfo.phoneMobile = "--";
      }
    }
  }

  getCoordinatesForCheckingJobblersInAndOut(loc, shiftId) {
    var _this = this;

    var shiftid = parseInt(shiftId, 10);

    _this.$events.getShiftRoster(shiftid).then(function (response) {
      var myLatLngEv = {
        lat: response.data.contactInfo.lat,
        lng: response.data.contactInfo.lng,
      };
      _this.coordsForCheckIn = myLatLngEv;
    });
  }

  findCurrentShift(applications) {
    var _this = this;

    let id = parseInt(_this.$stateParams.shiftId, 10);
    let sid = parseInt(_this.$location.$$search.i);

    console.log("ktrak1 what is the id...");
    console.dir(sid);

    try {
      applications.forEach(function (application) {
        for (var i = 0; i < application.jobble.shifts.length; i++) {
          console.log("ktrak2 comparing");
          console.dir(sid);
          console.dir(i);

          if (sid === i) {
            console.log("ktrak3 found one");
            console.dir(application.jobble.shifts[i]);

            application.table_data = {};
            application.table_data.buttons = {};
            application.table_data.icon_flags = {};

            let cs = application.jobble.shifts[i];

            console.log("we found the shift lets take a peak");
            console.dir(cs);

            if (!cs.managerCheckInTime && !cs.managerCheckOutTime) {
              console.log("nested if statement 1");
              application.table_data.buttons.show_checkout = false;
              application.table_data.buttons.show_checkin = true;
              application.table_data.icon_flags.showedit_starttime = false;
              application.table_data.icon_flags.showedit_endtime = false;
            } else if (cs.managerCheckInTime && !cs.managerCheckOutTime) {
              console.log("nested if statement 2");
              application.table_data.buttons.show_checkout = true;
              application.table_data.buttons.show_checkin = false;
              application.table_data.icon_flags.showedit_starttime = true;
              application.table_data.icon_flags.showedit_endtime = false;
            } else if (!cs.managerCheckInTime && cs.managerCheckOutTime) {
              console.log("nested if statement 3");
              application.table_data.buttons.show_checkout = false;
              application.table_data.buttons.show_checkin = false;
              application.table_data.icon_flags.showedit_starttime = false;
              application.table_data.icon_flags.showedit_endtime = true;
              application.table_data.disable_actions = true;
            } else {
              console.log("nested if statement 4");
              application.table_data.buttons.show_checkout = false;
              application.table_data.buttons.show_checkin = false;
              application.table_data.icon_flags.showedit_starttime = true;
              application.table_data.icon_flags.showedit_endtime = true;
              application.table_data.disable_actions = true;
            }

            console.log("each application");
            console.dir(application);
            application.currentShift = cs;

            break;
          }
        }
      });
    } finally {
      _this.$timeout(function () {
        //_this.$scope.$apply();
        console.log("applications lets see the current shifts");
        console.dir(applications);
        //_this.jobblers = applications;
        console.log("_this.jobblers");
        console.dir(_this.jobblers);
      }, 500);
    }
  }

  setTimeZones(applications) {
    var _this = this;

    console.log("setting the time zones");
    console.dir(applications);

    let applications_tz = _this.$security.getTimesFromZone(applications, true);

    _this.$timeout(function () {
      _this.jobblers = applications_tz;
    }, 300);
  }

  enterCheckInOutTime(jobbler, status, index) {
    var _this = this;

    _this.selectedstatus = status;

    _this.$timeout(function () {
      jQuery("#timepicker-rosterstamp").timepicker({
        step: 15,
        timeFormat: "h:i A",
      });
      jQuery("#timepicker-rosterstamp").on("showTimepicker", function () {
        jQuery(".ui-timepicker-wrapper").css("width", jQuery("#timepicker-rosterstamp").width() + 10 + "px");
      });

      _this.check_in_data = {};
      _this.check_in_data.application = jobbler;
      _this.check_in_data.status = status;
      _this.check_in_data.index = index;

      _this.selectedjobbler = jobbler;

      if (status === 1) {
        _this.selectedjobbler.checkInTimeFormatted = _this.showmanagerCheckInTime(jobbler.currentShift.checkInAndOutForDisplay.start_time);
      }

      if (status === 2) {
        _this.selectedjobbler.checkInTimeFormatted = _this.showmanagerCheckInTime(jobbler.currentShift.checkInAndOutForDisplay.end_time);
      }

      jQuery("#modal-check-user-in-link").modal();
    }, 100);
  }

  submitNewTimeForCheckInOrOut() {
    var _this = this;

    if (_this.selectedstatus === 1) {
      _this.calcTimeZone();
    }

    if (_this.selectedstatus === 2) {
      _this.calcTimeZone();
    }

    _this.$timeout(function () {
      jQuery("#modal-check-user-in").trigger("click");
    });
  }

  calcTimeZone() {
    var _this = this;

    console.log("calcTimeZone");
    console.dir(_this.selectedjobbler);

    var date = null;
    var userTimeZoneName = moment.tz.guess();
    var now = moment.tz(userTimeZoneName);
    var dayfull = moment().format("MMM DD YYYY");
    //this represents both check in and check out times
    var timefull = _this.selectedjobbler.checkInTimeFormatted;

    console.log("timefull");
    console.dir(timefull);
    console.dir(_this.selectedjobbler);

    var nowThere = moment.tz(_this.selectedjobbler.currentShift.contactInfo.place.timeZoneId);
    var timeInSec = (parseInt(now.utcOffset(), 10) - parseInt(nowThere.utcOffset())) * 60;
    var zone = moment.tz.zone(moment.tz.guess());
    var eventMangerOffsets = -zone.offsets[zone.offsets.length - 1];
    var eventOffsets = _this.selectedjobbler.currentShift.contactInfo.place.rawOffset / 60000;
    var fulldate = dayfull + " " + timefull;
    var dateconverted = new Date(fulldate);

    console.log("dateconverted");
    console.dir(dateconverted);

    var dateforDB = moment(dateconverted)
      .add(eventMangerOffsets - eventOffsets, "minutes")
      .format();

    let formatted_date = moment(dateconverted)
      .add(eventMangerOffsets - eventOffsets, "minutes")
      .format("hh:mm A");

    console.log("dates");
    console.dir(dateforDB);
    console.dir(formatted_date);

    if (_this.selectedstatus === 1) {
      _this.checkInForShift(_this.check_in_data.application, _this.check_in_data.index, formatted_date, dateforDB);
    }

    if (_this.selectedstatus === 2) {
      _this.checkOutForShift(_this.check_in_data.application, _this.check_in_data.index, formatted_date, dateforDB);
    }

    _this.$timeout(function () {
      $("#modal-check-user-in-link").modal("toggle");
    }, 300);
  }

  storeNewmanagerCheckInTime(date, formatted_date) {
    var _this = this;

    _this.$events.updateShiftCheckInTime(date, _this.selectedjobbler).then(function (response) {
      console.log("selectedjobblerselectedjobblerselectedjobbler");
      console.dir(_this.selectedjobbler);

      if (response.statusText === "OK") {
        _this.jobblers.some(function (elem) {
          if (elem.id === _this.selectedjobbler.id) {
            elem.currentShift.checkInAndOutForDisplay.start_time = formatted_date;
            return elem;
          }
        });
      } else {
        alert("There was an issue saving timestamp");
      }
    });
  }

  storeNewmanagerCheckOutTime(date, formatted_date) {
    var _this = this;

    _this.$events.updateShiftCheckOutTime(date, _this.selectedjobbler).then(function (response) {
      if (response.statusText === "OK") {
        _this.jobblers.some(function (elem) {
          if (elem.id === _this.selectedjobbler.id) {
            elem.currentShift.checkInAndOutForDisplay.end_time = formatted_date;
            return elem;
          }
        });
      } else {
        alert("There was an issue saving timestamp");
      }
    });
  }

  checkInForShift(application, index, date, date_for_db) {
    var _this = this;

    let jobbleAndApplicant = {};
    let payLoad = {jobblesAndApplicants: []};
    let now = null;

    if (!date) {
      now = moment().format("hh:mm A");
    } else {
      now = date;
      jobbleAndApplicant.date = date_for_db;
    }

    jobbleAndApplicant.jobble = application.jobble.id;
    jobbleAndApplicant.applicant = application.applicant.id;
    jobbleAndApplicant.coord = _this.coordsForCheckIn;
    jobbleAndApplicant.shift = application.currentShift.id;
    jobbleAndApplicant.isManager = true;

    payLoad.jobblesAndApplicants.push(jobbleAndApplicant);

    application.currentShift.managerCheckInTime = now;
    application.currentShift.checkInAndOutForDisplay.start_time = now;

    application.table_data.buttons.show_checkin = false;
    application.table_data.icon_flags.showedit_starttime = true;

    _this.$events.checkJobblerInOrOut(payLoad, 1).then(
      function (response) {
        _this.handleResponse(response, application, 1);

        _this.$timeout(function () {
          application.table_data.buttons.show_checkout = true;
        }, 500);
      },
      function (data) {
        _this.remain_loading_count = 0;

        /*
		  _this.$timeout(function(){
			  alert('failure: contact support');
		  }, 400);
		  */
      }
    );
  }

  checkOutForShift(application, index, date, date_for_db) {
    var _this = this;

    let jobbleAndApplicant = {};
    let payLoad = {jobblesAndApplicants: []};
    let now = null;

    if (!date) {
      now = moment().format("hh:mm A");
    } else {
      now = date;
      jobbleAndApplicant.date = date_for_db;
    }

    jobbleAndApplicant.jobble = application.jobble.id;
    jobbleAndApplicant.applicant = application.applicant.id;
    jobbleAndApplicant.coord = _this.coordsForCheckIn;
    jobbleAndApplicant.shift = application.currentShift.id;
    jobbleAndApplicant.isManager = true;

    payLoad.jobblesAndApplicants.push(jobbleAndApplicant);

    application.currentShift.managerCheckOutTime = now;
    application.currentShift.checkInAndOutForDisplay.end_time = now;
    application.table_data.disable_actions = true;

    _this.$events.checkJobblerInOrOut(payLoad, 2).then(
      function (response) {
        _this.handleResponse(response, application, 2);
      },
      function (data) {
        _this.remain_loading_count = 0;

        /*
		  _this.$timeout(function(){
			  alert('failure: contact support');
		  }, 400)
		  */
      }
    );
  }

  getHeader() {
    return ["Last Name", "First Name", "Number", "Email", "Post Title", "Job Type", "City", "State", "Zip", "Apply Date"];
  }

  downloadRoster() {
    console.log("downloadRoster");
    console.dir(this.csv);
  }

  showTime(shift, time) {
    var _this = this;

    console.log("show time");
    console.dir(shift);
    console.dir(time);

    return _this.$security.displayTimeWithZone(time, shift.contactInfo.place.timeZoneId);
  }

  sortSurveyQuestions(questions) {
    var _this = this;
    questions.sort(function (a, b) {
      if (a.id < b.id) return -1;
      if (a.id > b.id) return 1;
      return 0;
    });
  }

  displayDetails(application) {
    var _this = this;

    console.log("display");
    console.dir(application);

    _this.setLoader();
    _this.$timeout(function () {
      jQuery("#modal-view-jobble").modal();
    });

    _this.$security.getApplicationInfoTrimmed(application).then(function (response) {
      var jobblerData = _this.$security.getJobblerData(response.data, "hired", "open", application.renderPhotoBig, null, null, null);
      _this.sortSurveyQuestions(jobblerData.surveyQuestions);
      //jobblerData.index = applicationIndexInArray;
      jobblerData.type = "hired";
      jobblerData.action = "open";

      /*
		  if (isLink) {
			  _this.$location.search('id', jobblerData.jobblerId);
		  }
		   */
      _this.$timeout(function () {
        _this.$rootScope.$emit("GetJobblerDataFromService", {
          event: _this.event,
          jobblerData: jobblerData,
          messaging: false,
          application: application,
          type: "hired",
        });

        $("#modal-view-jobble").focus();
      });

      _this.$timeout(function () {
        _this.unSetLoader();
      }, 500);
    });
  }

  updateConfirmationUI(data) {
    var _this = this;

    console.log("updateConfirmationUI");
    console.dir(data);
    console.dir(_this.jobblers);

    let app = _this.jobblers.find((o) => o.applicant.id === data.userId);

    app.currentShift.confirmationDateTime = data.timestamp;

    if (data.type) {
      app.currentShift.confirmationResponse = false;
    } else {
      app.currentShift.confirmationResponse = true;
    }
  }

  setLoader() {
    var _this = this;
    _this.$timeout(function () {
      $("html").addClass("wait");
    });
  }

  unSetLoader() {
    var _this = this;
    _this.$timeout(function () {
      $("html").removeClass("wait");
    });
  }

  triggerConfirmationModal(application) {
    var _this = this;

    _this.setLoader();

    console.log("triggerConfirmationModal");
    console.dir(application);

    _this.getJobblesAndShifts(application);

    /*
	  _this.$timeout(function(){
		  $("#modal-view-jobble").modal("toggle");
	  });
	  */

    /*
	  _this.$timeout(function(){
		  $("#modal-confirm-jobbler").modal();
	  },300);
	  */
    _this.$timeout(function () {
      $("#modal-confirm-jobbler").modal();
    }, 300);
  }

  getJobblesAndShifts(app) {
    var _this = this;

    console.log("getJobblesAndShifts");
    console.dir(app);
    app.jobbleId = app.jobble.id;
    _this.$jobs.getJobbleWithShifts(app.jobbleId).then(
      function (response) {
        console.log("get jobble with shifts");
        console.dir(response);
        _this.format_time_zones(response.data.shifts, app);

        _this.unSetLoader();
      },
      function (error) {
        console.log("in error");
        console.dir(error);
      }
    );
  }

  format_time_zones(shifts, app) {
    var _this = this;

    try {
      shifts.forEach(function (shift) {
        console.log("-------------each shift");
        console.dir(shift.timeInterval.startTime);
        shift.startTimeFormatted = moment(shift.timeInterval.startTime).tz(shift.contactInfo.place.timeZoneId).format("MM/DD/YYYY hh:mm A");
        shift.endTimeFormatted = moment(shift.timeInterval.endTime).tz(shift.contactInfo.place.timeZoneId).format("MM/DD/YYYY hh:mm A");
        if (shift.confirmationDateTime) {
          shift.confirmationDateTimeFormatted = moment(shift.confirmationDateTime)
            .tz(shift.contactInfo.place.timeZoneId)
            .format("MM/DD/YYYY hh:mm A");
        }
        if (shift.confirmationResponse === true) {
          shift.confirmationResponseDisplay = "Yes";
        } else {
          shift.confirmationResponseDisplay = "No";
        }
      });
    } catch (err) {
    } finally {
      shifts.sort(function (a, b) {
        return new Date(a.timeInterval.startTime).getTime() - new Date(b.timeInterval.startTime).getTime();
      });

      _this.$timeout(function () {
        _this.$rootScope.$emit("SetShiftsToModal", {shifts, app});
      });

      //_this.shifts_for_confirm = shifts;
      console.log("shifts_for_confirm");
      console.dir(_this.shifts_for_confirm);
    }
  }
}
EventrosterController.$inject = [
  "$http",
  "$localStorage",
  "$scope",
  "$state",
  "jobs",
  "auth",
  "events",
  "$stateParams",
  "security",
  "$rootScope",
  "env",
  "$timeout",
  "$location",
];

export default EventrosterController;



// WEBPACK FOOTER //
// ./client/app/components/eventroster/eventroster.controller.js